export const approTemplatesApi = {
  listDsApproTemplateByDsId: '/clouddm/console/api/v1/dsapprotemplate/listdsapprotemplatebydsid',
  modifyDsApproTemplates: '/clouddm/console/api/v1/dsapprotemplate/modifydsapprotemplates'
};
